import { CommonCMS } from "@lib/constants/contentful";
import type { FormikState } from "formik";
import { BaseField } from "../base-field/BaseField";
import { Password } from "../password-field/PasswordField";
import type { Field, Values } from "../../types";
import type { ReactNode } from "react";

type Props = {
    microcopies: unknown;
    withNames?: boolean;
    field: Field;
    values?: Partial<Values>;
} & Pick<FormikState<Values>, "errors" | "touched">;

export const FieldsMapping = ({
    errors,
    touched,
    microcopies,
    withNames,
    field,
    values,
}: Props) => {
    const config: Record<Field, ReactNode> = {
        firstName: (
            <BaseField
                label={microcopies[CommonCMS.firstName]}
                error={errors.firstName}
                touched={touched.firstName}
                fieldType="firstName"
                display={withNames ? "none" : "block"}
            />
        ),
        lastName: (
            <BaseField
                label={microcopies[CommonCMS.lastName]}
                error={errors.lastName}
                touched={touched.lastName}
                fieldType="lastName"
                display={withNames ? "none" : "block"}
            />
        ),
        email: (
            <BaseField
                label={microcopies[CommonCMS.email]}
                error={errors.email}
                touched={touched.email}
                fieldType="email"
                isDisabled={!!values?.email}
            />
        ),
        password: (
            <Password
                description={microcopies[CommonCMS.passwordRules]}
                label={microcopies[CommonCMS.password]}
                error={errors.password}
                touched={touched.password}
            />
        ),
        dateOfBirth: (
            <BaseField
                fieldType="dateOfBirth"
                label={microcopies[CommonCMS.dateOfBirth]}
                error={errors.dateOfBirth}
                touched={touched.dateOfBirth}
            />
        ),
        phoneticFirstName: (
            <BaseField
                fieldType="phoneticFirstName"
                label={microcopies[CommonCMS.phoneticFirstName]}
                error={errors.phoneticFirstName}
                touched={touched.phoneticFirstName}
                display={withNames ? "none" : "block"}
            />
        ),
        phoneticLastName: (
            <BaseField
                fieldType="phoneticLastName"
                label={microcopies[CommonCMS.phoneticLastName]}
                error={errors.phoneticLastName}
                touched={touched.phoneticLastName}
                display={withNames ? "none" : "block"}
            />
        ),
    };
    return config[field];
};
